<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
//vue使用
//在app.vue或者其它全局的文件中引入函数
// import DevicePixelRatio from '@/assets/js/devicePixelRatio';
export default {
  name: 'App',
  //在vue生命周期created中添加
  created() {
    // new DevicePixelRatio().init();
  },
  // //其它使用
  // //全局引入devicePixelRatio.js
  // //在页面加载之时，调用此方法初始化页面比例
  // new DevicePixelRatio().init();
};
</script>
